import type { Components } from "@mui/material/styles";

import type { Theme } from "../types";

export const MuiCardContent = {
	styleOverrides: {
		root: ({ theme }) => ({
			padding: theme.spacing(2),
			"&:last-child": { paddingBottom: theme.spacing(2) },
			[theme.breakpoints.up("sm")]: {
				padding: theme.spacing(3),
				"&:last-child": { paddingBottom: theme.spacing(3) },
			},
		}),
	},
} satisfies Components<Theme>["MuiCardContent"];
